module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n    <div class="m-modal-column"></div>\n\n\n\n\n    <div class="m-modal-section" >\n        <div class="m-modal-section__title">Real-time controls</div>\n\n            <div class="m-modal-column">\n                <div class="form-group">\n                    <label for="name">GPIO Value</label>\n                    <select class="form-control js-gpio" >\n                        <option value="">Please choose a value...</option>\n                        \n                        ';
 for(var i=0; i<=255; i++) {
__p+='\n                            <option value="'+
((__t=( i ))==null?'':__t)+
'">'+
((__t=( i ))==null?'':__t)+
'</option>\n\n                        ';
 } 
__p+='\n\n                    </select>\n                </div>\n\n        </div>\n    </div>\n\n\n\n  ';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/control/templates/control-rtm-io.html
// module id = 434
// module chunks = 0